var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('b-card',{staticClass:"div-card"},[_c('b-card-body',[_c('h2',[_vm._v("Página não encontrada. Clique em "),_c('b-link',{on:{"click":function($event){return _vm.redirect()}}},[_vm._v("Home")]),_vm._v(" para ser redirecionado.")],1)])],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-824dd6f4","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/notfoundpage/NotFoundPage.vue
// module id = null
// module chunks = 